export default __webpack_public_path__ + "static/bra-betalningsalternativ-pa-casinon-1eb7e3dd0f3dfd92b2d41692f34ccdc8.jpg";